// src/utils/routeTokens.js
export function buildTokenListFromResponse(resp) {
  const dbg = resp?.debug?.expanded_tokens;
  if (Array.isArray(dbg) && dbg.length) {
    return dbg.map((s) => String(s).toUpperCase());
  }
  const out = [];
  if (resp?.originIcao) out.push(String(resp.originIcao).toUpperCase());
  if (Array.isArray(resp?.waypoints)) {
    for (const wp of resp.waypoints) {
      if (wp?.id) out.push(String(wp.id).toUpperCase());
    }
  }
  if (resp?.destinationIcao) out.push(String(resp.destinationIcao).toUpperCase());
  return out;
}

export function coordForToken(resp, token) {
  const T = String(token).toUpperCase();
  // origin
  if (resp?.originIcao && String(resp.originIcao).toUpperCase() === T && Array.isArray(resp.origin)) {
    return [resp.origin[0], resp.origin[1]]; // [lon, lat]
  }
  // destination
  if (resp?.destinationIcao && String(resp.destinationIcao).toUpperCase() === T && Array.isArray(resp.destination)) {
    return [resp.destination[0], resp.destination[1]];
  }
  // waypoints
  if (Array.isArray(resp?.waypoints)) {
    const wp = resp.waypoints.find(w => String(w?.id).toUpperCase() === T);
    if (wp?.coordinates && wp.coordinates.length === 2) {
      return [wp.coordinates[0], wp.coordinates[1]];
    }
  }
  return null;
}

// Build a short line feature for highlight between token i and i+1 (if both coords exist)
export function highlightSegmentFeature(resp, tokens, idx) {
  if (idx < 0 || idx >= tokens.length - 1) return null;
  const a = coordForToken(resp, tokens[idx]);
  const b = coordForToken(resp, tokens[idx + 1]);
  if (!a || !b) return null;
  return {
    type: 'Feature',
    geometry: { type: 'LineString', coordinates: [a, b] },
    properties: { a: tokens[idx], b: tokens[idx+1] }
  };
}
